import React from "react";
import SingleReview from "./SingleReview";
import SortingSection from "./SortingSection";
import WriteReview from "./WriteReview";

const ProductReviews = ({ productId, reviews }) => {
  return (
    <div>
      <WriteReview productId={productId} />
      <SortingSection />
      {reviews?.length === 0 && (
        <h3 className="text-center">No Reviews Added</h3>
      )}
      {reviews?.map((review) => (
        <SingleReview key={review?._id} review={review} />
      ))}
    </div>
  );
};

export default ProductReviews;
